import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-period-index',
  templateUrl: './select-period-index.component.html',
  styleUrls: ['./select-period-index.component.scss']
})
export class SelectPeriodIndexComponent implements  OnDestroy {

  public items: any[] = [
    { name: 'General', value: null },
    { name: 'Diario', value: 'day' },
    { name: 'Semanal', value: 'week' },
    { name: 'Mensual', value: 'month' }
  ];

  public period: any = [];
  public ngxDisabled = false;
  period$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.period$ = this.sharedService.sharedPeriodIndex.subscribe(period => {
      this.period = period;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.period$.unsubscribe();
  }

  changePeriod(event: any) {
    this.period = event;
    this.sharedService.nextPeriodIndex = this.period;
  }
}
